import {
  trackTradidionalGaEvent,
  EventInfoCategory,
  EventInfoAction,
} from '@/components/GoogleTagManager';

const campaignFormsBlock =
  document.getElementsByClassName('CampaignFormsBlock');

if (campaignFormsBlock) {
  // loop through all campaign forms blocks on page (there can be more than one, but most likely only one)
  Array.from(campaignFormsBlock).forEach((element) => {
    if (element) {
      // set height for image box to same as form box
      const hightBox = element.querySelector('.Formbox');
      const imageBox = element.querySelector('.image-box');
      if (hightBox && imageBox) {
        const clientHeightpx = hightBox.clientHeight + 'px';
        imageBox.setAttribute('style', `height: ${clientHeightpx}`);
      }
    }

    // check if form exist and add GA tracking event on submit
    const form = element.querySelector('.EPiServerForms');
    if (form) {
      // fetch value from h2 tag
      const h2Elem = element.querySelector('.Form__Title');
      let formTitle = form.id; // default to form id (this is a guid)
      if (h2Elem && h2Elem.textContent) {
        formTitle = h2Elem.textContent;
      }

      // add event listener to submit button and send GTM event
      const submitButton = form.querySelector('button[type=submit]');
      if (submitButton) {
        submitButton.addEventListener('click', function () {
          trackTradidionalGaEvent(
            EventInfoCategory.Campaign,
            EventInfoAction.Button,
            formTitle
          );
        });
      }
    }
  });
}
